import {Constants} from '../../helpers';
import * as Assets from '../../assets/images/images';

const reconciloNavLinks = [
  {
    url: Constants.PAGES_URL.PROJECT_ACCOUNTS,
    imgSrc: Assets.projectsNav,
    label: 'Accounts',
  },
  {
    url: Constants.PAGES_URL.PROJECT_TRANSACTIONS,
    imgSrc: Assets.transactionsNav,
    label: 'Transactions',
  },
  {
    url: Constants.PAGES_URL.PROJECT_RECONCILIATION,
    imgSrc: Assets.discrepanciesNav,
    label: 'Reconciliation',
  },
  {
    url: Constants.PAGES_URL.PROJECT_CUSTOMERS,
    imgSrc: Assets.usersNav,
    label: 'Customers',
  },
  {
    url: Constants.PAGES_URL.PROJECT_SETTINGS,
    imgSrc: Assets.settingsNav,
    label: 'Project Settings',
  },
];

export {reconciloNavLinks};
